import React from "react";
import styles from "./collectionCard.module.scss";
import { Media } from "../../../../types/media";
import Tooltip from "src/components/tooltip/index";
import Thumbnail from "src/components/thumbnail";
import { useHubAdoption } from "src/redux/actions/adoption/hub";
import _ from "lodash";
import cx from "classnames";
import { useNavigate } from "react-router-dom";
import { NavigateEntity } from "src/components/NavigateEntity";
import Text from "src/components/text"

interface BannerBackground {
  full?: string;
  thumbnail?: string;
  id?: string;
  key?: string;
  type?: string;
}

interface Banner {
  background?: BannerBackground;
}

interface CollectionIconProps {
  id: string;
  icon?: Media;
  name?: string;
  assets: number | string;
  sections: number | string;
  internal: boolean;
  banner?: Banner;  
  classnames?: string;
}

// Render the count of assets or sections
const renderContentCount = (assetsCount: number, sectionsCount: number) => {
  if (sectionsCount > 0) {
    return (
      <div className={styles.contentCount}>
        {sectionsCount} {sectionsCount > 1 ? "sections" : "section"}
      </div>
    );
  }
  return (
    <div className={styles.contentCount}>
      {assetsCount} {assetsCount === 1 ? "asset" : "assets"}
    </div>
  );
};

// Main CollectionCard component
export function CollectionCard({
  id,
  icon,
  name,
  banner,
  assets,
  sections,
  internal,
  classnames,
}: CollectionIconProps) {
  const navigate = useNavigate();
  const { trackCollectionViewedEvent } = useHubAdoption();

  const thumbnailUrl = _.get(banner, "background");

  return (
    <div>
    <NavigateEntity
      path={`/collections/${id}`}
      className={styles.cursorPointer}
      onClick={() => {
        trackCollectionViewedEvent(name || "") 
        navigate(`/collections/${id}`)
      }}
      >
      <div className={cx(styles.collectionIcon, classnames)}>
      {internal &&
          <div className={styles.indicators}>
            <Tooltip content={'Internal use only'} placement='top'>
              <i className="paperflite-lock"></i>
            </Tooltip>
          </div>
          }
        <Thumbnail
          media={thumbnailUrl as Media}
          className={styles.thumbnail}
          alt="stream thumbnail"
          defaultImage="/images/collections/background.jpeg"
          width={800}
        />
      </div>
      <div className={styles.collectionName}>
      <Text text={name} />
      </div>
      {renderContentCount(Number(assets), Number(sections))}
      </NavigateEntity>
    </div>
  );
}

// Placeholder version of CollectionCard
export function PlaceholderCollectionCard() {
  return (
    <div className={cx(styles.placeholder, styles.block)}>
      <div className={cx(styles.collectionIcon, styles.block)}></div>
      <p className={cx(styles.collectionName, styles.block)}></p>
      <div className={cx(styles.contentCount, styles.block)}></div>
    </div>
  );
}
